// extracted by mini-css-extract-plugin
export default {"inlineLink":"Welcome_inlineLink__pcph-","divider":"Welcome_divider__fw0kL","story":"Welcome_story__ToxRm"};